var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyclingRoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.9,
    cy: 39.9,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6,70.9L39.4,43.7C37.1,46,36,48.9,36,51.9v61.3c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1V98.6l20.3-20.3 C68.6,76.2,68.6,73,66.6,70.9z M46.3,84V65.1l9.4,9.4L46.3,84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7,66.9c-1.6,0-3.2,0.1-4.7,0.4V50.1c0-2.3-0.9-4.6-2.6-6.4c-1.7-1.7-3.9-2.6-6.1-2.6H44.1l18,18h20.6v11.6v0 c-9.5,5.3-15.9,15.4-15.9,27c0,17,13.8,30.9,30.9,30.9s30.9-13.8,30.9-30.9S114.8,66.9,97.7,66.9z M117.6,117.6 c-5.3,5.3-12.4,8.2-19.9,8.2c-7.5,0-14.6-2.9-19.9-8.2c-5.3-5.3-8.2-12.4-8.2-19.9c0-7.5,2.9-14.6,8.2-19.9 c1.7-1.7,3.6-3.2,5.7-4.4c0.2,0.3,0.5,0.6,0.7,0.9l16.4,16.4c2,2,5.3,2,7.3,0s2-5.3,0-7.3L94.2,69.8c1.1-0.1,2.3-0.2,3.5-0.2 c7.5,0,14.6,2.9,19.9,8.2c5.3,5.3,8.2,12.4,8.2,19.9C125.9,105.2,122.9,112.3,117.6,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,66.9v2.7c7.5,0,14.6,2.9,19.9,8.2s8.2,12.4,8.2,19.9c0,7.5-2.9,14.6-8.2,19.9c-5.3,5.3-12.4,8.2-19.9,8.2v2.7 c17,0,30.9-13.8,30.9-30.9S17,66.9,0,66.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclingRoad);
export default __webpack_public_path__ + "static/media/cyclingRoad.bd95aeece4ea56eea003716ec7aa1350.svg";
export { ForwardRef as ReactComponent };